import { AppRouteProps, AppRoutes } from '../../common/utils/app-routes';

const root = AppRouteProps[AppRoutes.AccountsManagement].path;

export const withRoot = (relativePath: string) => `${root}/${relativePath}`;
